import React, { Component } from "react";
// COMP FROM OLD ONES
import { Row, Image, Container, Modal } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import NotificationBlock from "./NotificationBoxComponent";
import BottomNavigationMobile from "../navigationSection/BottomNavigationMobile";
import MarkAsReadIcon from "../../../assets/images/UserManagement/mark.svg";
import ClearAllIcon from "../../../assets/images/UserManagement/clear.svg";

// POPUP BY
import ViewUserDetailsPopup from "./ViewUserNotificationDetailsPopup";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  get_all_notifications,
  get_single_notifications,
  update_notification,
  update_all_notification,
  mark_all_as_read,
  clear_all_as_read,
} from "../../../store/actions/notificationActions";
import { get_notification_count } from "../../../store/actions/authAction";
import isEmpty from "../../../store/validation/is-Empty";
// import { Button } from "react-bootstrap";
import Media from "react-media";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import ButtonsYesNo from "./ButtonsYesNo";
import { SET_NOTIFICATION_PAGE_INFO } from "../../../store/types";
import store from "../../../store/store";

export class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pending: [],
      reservation: [],
      walkins: [],
      allSingleNotification: [],
      displayObject: {},
      displayPopup: false,
      insidePageTab: "",
      insidePageText: "NO",
      clearReadModal: false,
      anchorEl: null,
      ordering: null,
      hasSetUpdate: false,
    };
  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleOrderingClick = (event) => {
    this.setState({
      ordering: event.currentTarget,
    });
  };
  handleOrderingClose = () => {
    this.setState({
      ordering: null,
    });
  };

  // CALL COMPONENTDIDMOUNT TO BRING ALL THE DATA FROM NOTIFICATIONS
  componentDidMount() {
    this.setState(
      {
        insidePageTab:
          this.props?.casualDiningService ||
          this.props?.fastFoodDiningService ||
          this.props?.multiDiningService
            ? this.props?.subscriptionData?.seating?.value
              ? this.props?.subscriptionData?.seating?.walkin_waitlist?.value
                ? 1
                : this.props?.subscriptionData?.seating?.reservation?.value
                ? 2
                : ""
              : this.props?.subscriptionData?.event_management?.value
              ? this.props?.subscriptionData?.event_management?.offline_event
                  ?.rsvp?.value
                ? 3
                : this.props?.subscriptionData?.event_management?.offline_event
                    ?.booking_enabled?.value
                ? 4
                : ""
              : this.props?.subscriptionData?.offer_management?.value
              ? 5
              : this.props?.subscriptionData?.ordering?.value
              ? this.props?.subscriptionData?.ordering?.take_away?.value
                ? 6
                : this.props?.subscriptionData?.ordering?.cubside_delivery
                    ?.value
                ? 7
                : this.props?.subscriptionData?.ordering?.self_serve?.value
                ? 8
                : this.props?.subscriptionData?.ordering?.dine_in_order?.value
                ? 9
                : this.props?.subscriptionData?.ordering?.catering_banquet
                    ?.value
                ? 11
                : this.props?.subscriptionData?.ordering?.home_delivery?.value
                ? 13
                : 0
              : 0
            : 0,
        insidePageText:
          this.props?.casualDiningService ||
          this.props?.fastFoodDiningService ||
          this.props?.multiDiningService
            ? this.props?.subscriptionData?.seating?.value
              ? this.props?.subscriptionData?.seating?.walkin_waitlist?.value
                ? "SEATING"
                : this.props?.subscriptionData?.seating?.reservation?.value
                ? "RESERVATION"
                : ""
              : this.props?.subscriptionData?.event_management?.value
              ? this.props?.subscriptionData?.event_management?.offline_event
                  ?.rsvp?.value
                ? "RSVP"
                : this.props?.subscriptionData?.event_management?.offline_event
                    ?.booking_enabled?.value
                ? "TICKET_BOOKED"
                : ""
              : this.props?.subscriptionData?.offer_management?.value
              ? "OFFERS"
              : this.props?.subscriptionData?.ordering?.value
              ? this.props?.subscriptionData?.ordering?.take_away?.value
                ? "TAKEAWAY"
                : this.props?.subscriptionData?.ordering?.cubside_delivery
                    ?.value
                ? "CURBSIDE"
                : this.props?.subscriptionData?.ordering?.self_serve?.value
                ? "SKIPTHELINE"
                : this.props?.subscriptionData?.ordering?.dine_in_order?.value
                ? "DINEIN"
                : this.props?.subscriptionData?.ordering?.catering_banquet
                    ?.value
                ? "CATERING"
                : this.props?.subscriptionData?.ordering?.home_delivery?.value
                ? "HOMEDELIVERY"
                : "NO"
              : "NO"
            : "NO",
      },
      () =>
        this.props.get_single_notifications(
          this.props.auth.user.VendorUser._id,
          this.state.insidePageText,
          () =>
            this.onSuccessSingleNotification(
              this.state.insidePageTab,
              this.state.insidePageText
            )
        )
    );

    // if (this.state.insidePageText !== "SEATING") {

    // }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.notification !== nextState.allSingleNotification) {
      return {
        allSingleNotification: nextProps.notification,
        insidePageTab:
          nextProps?.casualDiningService ||
          nextProps?.fastFoodDiningService ||
          nextProps?.multiDiningService
            ? nextProps?.subscriptionData?.seating?.value
              ? nextProps?.subscriptionData?.seating?.walkin_waitlist?.value
                ? 1
                : nextProps?.subscriptionData?.seating?.reservation?.value
                ? 2
                : ""
              : nextProps?.subscriptionData?.event_management?.value
              ? nextProps?.subscriptionData?.event_management?.offline_event
                  ?.rsvp?.value
                ? 3
                : nextProps?.subscriptionData?.event_management?.offline_event
                    ?.booking_enabled?.value
                ? 4
                : ""
              : nextProps?.subscriptionData?.offer_management?.value
              ? 5
              : nextProps?.subscriptionData?.ordering?.value
              ? nextProps?.subscriptionData?.ordering?.take_away?.value
                ? 6
                : nextProps?.subscriptionData?.ordering?.cubside_delivery?.value
                ? 7
                : nextProps?.subscriptionData?.ordering?.self_serve?.value
                ? 8
                : nextProps?.subscriptionData?.ordering?.dine_in_order?.value
                ? 9
                : nextProps?.subscriptionData?.ordering?.catering_banquet?.value
                ? 11
                : nextProps?.subscriptionData?.ordering?.home_delivery?.value
                ? 13
                : 0
              : 0
            : 0,
        insidePageText:
          nextProps?.casualDiningService ||
          nextProps?.fastFoodDiningService ||
          nextProps?.multiDiningService
            ? nextProps?.subscriptionData?.seating?.value
              ? nextProps?.subscriptionData?.seating?.walkin_waitlist?.value
                ? "SEATING"
                : nextProps?.subscriptionData?.seating?.reservation?.value
                ? "RESERVATION"
                : ""
              : nextProps?.subscriptionData?.event_management?.value
              ? nextProps?.subscriptionData?.event_management?.offline_event
                  ?.rsvp?.value
                ? "RSVP"
                : nextProps?.subscriptionData?.event_management?.offline_event
                    ?.booking_enabled?.value
                ? "TICKET_BOOKED"
                : ""
              : nextProps?.subscriptionData?.offer_management?.value
              ? "OFFERS"
              : nextProps?.subscriptionData?.ordering?.value
              ? nextProps?.subscriptionData?.ordering?.take_away?.value
                ? "TAKEAWAY"
                : nextProps?.subscriptionData?.ordering?.cubside_delivery?.value
                ? "CURBSIDE"
                : nextProps?.subscriptionData?.ordering?.self_serve?.value
                ? "SKIPTHELINE"
                : nextProps?.subscriptionData?.ordering?.dine_in_order?.value
                ? "DINEIN"
                : nextProps?.subscriptionData?.ordering?.catering_banquet?.value
                ? "CATERING"
                : nextProps?.subscriptionData?.ordering?.home_delivery?.value
                ? "HOMEDELIVERY"
                : "NO"
              : "NO"
            : "NO",
      };
    }
    return null;
  }

  onClickRemove = (obj, pageTab, actionBy) => {
    // Mark image as archive
    const vendor_id = this.props.auth.user.VendorUser._id;
    let formData = {
      id: obj._id,
      remove: true,
    };
    this.props.update_notification(formData, vendor_id, () =>
      this.onSuccessUpdateNotification(pageTab, actionBy)
    );
  };

  onDoubleClick = (obj) => {
    // Open the model
    this.setState({
      displayObject: obj,
      displayPopup: true,
    });
  };

  onSingleClick = (obj, pageTab, actionBy) => {
    // MARK AS READ
    const vendor_id = this.props.auth.user.VendorUser._id;
    let formData = {
      id: obj._id,
      read: true,
    };
    this.props.update_notification(formData, vendor_id, () =>
      this.onSuccessUpdateNotification(pageTab, actionBy)
    );
  };

  onSuccessUpdateNotification = (type, actionBy) => {
    this.setState({
      insidePageTab: type,
      insidePageText: actionBy,
    });
    let formData = {
      insidePageTab: type,
      insidePageText: actionBy,
    };
    store.dispatch({ type: SET_NOTIFICATION_PAGE_INFO, payload: formData });
    this.props.get_single_notifications(
      this.props.auth.user.VendorUser._id,
      actionBy,
      () => this.onSuccessSingleNotification(type, actionBy)
    );
  };

  onMarkasReadAll = (e) => {
    const vendor_id = this.props.auth.user.VendorUser._id;
    let formData = {
      markAllRead: true,
      serviceType: this.state.insidePageText,
    };
    this.props.mark_all_as_read(
      formData,
      vendor_id,
      this.state.insidePageText,
      () =>
        this.onSuccessMarkClearAllRead(
          vendor_id,
          this.state.insidePageTab,
          this.state.insidePageText
        )
    );
  };

  onClearAllReadItemModalShow = (e) => {
    this.setState({
      clearReadModal: true,
    });
  };

  handleCloseModal = (e) => {
    this.setState({
      clearReadModal: false,
    });
  };

  onClearAllReadItem = (e) => {
    const vendor_id = this.props.auth.user.VendorUser._id;
    let formData = {
      clearRead: true,
      // serviceType: this.state.insidePageText,
    };
    this.props.clear_all_as_read(
      formData,
      vendor_id,
      this.state.insidePageText,
      () =>
        this.onSuccessMarkClearAllRead(
          vendor_id,
          this.state.insidePageTab,
          this.state.insidePageText
        )
    );
    this.setState({
      clearReadModal: false,
    });
  };

  onSuccessMarkClearAllRead = (vendorId, pageType, pageAction) => {
    this.props.get_single_notifications(vendorId, pageAction, () =>
      this.onSuccessSingleNotification(pageType, pageAction)
    );
  };

  onCloseModal = (e) => {
    this.setState({
      displayObject: {},
      displayPopup: false,
    });
  };

  localProps = {
    onClickRemove: this.onClickRemove,
    onDoubleClick: this.onDoubleClick,
    onMarkasRead: this.onMarkasRead,
    onClearAllReadItem: this.onClearAllReadItem,
    onSingleClick: this.onSingleClick,
    onCloseModal: this.onCloseModal,
  };

  pageChangeButtonClickHandler = (type, actionBy) => (e) => {
    this.setState({
      insidePageTab: type,
      insidePageText: actionBy,
    });
    this.props.get_single_notifications(
      this.props.auth.user.VendorUser._id,
      actionBy,
      () => this.onSuccessSingleNotification(type, actionBy)
    );
  };

  onDropDownHandleClick = (type, actionBy) => (e) => {
    this.setState({
      insidePageTab: type,
      insidePageText: actionBy,
    });
    this.props.get_single_notifications(
      this.props.auth.user.VendorUser._id,
      actionBy,
      () => this.onSuccessSingleNotification(type, actionBy)
    );
    this.handleClose();
    this.handleOrderingClose();
  };

  onSuccessSingleNotification = (type, actionBy) => {
    let formData = {
      insidePageTab: type,
      insidePageText: actionBy,
    };
    store.dispatch({ type: SET_NOTIFICATION_PAGE_INFO, payload: formData });
    this.setState({
      insidePageTab: type,
      insidePageText: actionBy,
    });
    const token = this.props?.auth?.user?.accessToken;
    this.props.get_notification_count(token);
  };

  render() {
    const {
      casualDiningService,
      fastFoodDiningService,
      multiDiningService,
      subscriptionData,
    } = this.props;

    return (
      <React.Fragment>
        {this.state.displayPopup ? (
          <ViewUserDetailsPopup
            localProps={this.localProps}
            sendData={
              !isEmpty(this.state.displayObject) ? this.state.displayObject : ""
            }
          />
        ) : null}
        <Container fluid className="main-seating-dashboard-body">
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
            </Media>
            {/* <div className="top-panel">
              <TopNavigationBarMobile
                displayLeft="backButton"
                backLink="/seatingdashboard"
                displayRight={false}
                headText="Notification"
              />
            </div> */}
            <div className="right-side-panel mobile-px-15 ">
              <RightSideNavigation />
              <Media query="(min-width: 992px)">
                <div className="row justify-content-between align-items-center">
                  <div className="col-md-6 f24_700_HelveticaNeue">
                    Notifications
                  </div>
                  <div className="action-buttons mb-3 col-md-6">
                    <div
                      className="action-button flex-column align-items-center"
                      onClick={this.onMarkasReadAll}
                    >
                      <img src={MarkAsReadIcon} alt="notificationIcon" />
                      <span className="f9-400 w-100 mt-2">Mark All Read</span>
                    </div>
                    <div
                      className="action-button  flex-column align-items-center"
                      onClick={this.onClearAllReadItemModalShow}
                    >
                      <img
                        className="clear-all"
                        src={ClearAllIcon}
                        alt="notificationIcon"
                      />
                      <span className="f9-400 w-100 mt-2">
                        Clear Read Items
                      </span>
                    </div>
                  </div>
                </div>
              </Media>
              <Media query="(max-width: 992px)">
                <div className="row justify-content-between align-items-center">
                  <div className="col-md-6 f12_700_HelveticaNeue">
                    {/* Notifications */}
                  </div>
                  <div className="action-buttons mb-3 col-md-6">
                    <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                      Notifications
                    </div>
                    <div
                      className="action-button flex-column align-items-center"
                      onClick={this.onMarkasReadAll}
                    >
                      <img src={MarkAsReadIcon} alt="notificationIcon" />
                      <span className="f12-400 w-100 mt-2">Mark All Read</span>
                    </div>
                    <div
                      className="action-button  flex-column align-items-center"
                      onClick={this.onClearAllReadItemModalShow}
                    >
                      <img
                        className="clear-all"
                        src={ClearAllIcon}
                        alt="notificationIcon"
                      />
                      <span className="f12-400 w-100 mt-2">
                        Clear Read Items
                      </span>
                    </div>
                  </div>
                </div>
              </Media>
              <Modal
                show={this.state.clearReadModal}
                onHide={this.handleCloseModal}
                centered
              >
                <Modal.Header className="py-0 pt-2 border-0" closeButton>
                  <Modal.Title className="f24_500_HelveticaNeue">
                    Clear Items
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="f14-400 pb-4">
                    Are you sure you want to clear all read items?
                  </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-start border-0">
                  <ButtonsYesNo
                    handleCloseModal={this.handleCloseModal}
                    onClearAllReadItem={this.onClearAllReadItem}
                  />
                </Modal.Footer>
              </Modal>
              <Media query="(min-width: 992px)">
                <div className="nav-scroller py-1 h-auto">
                  <div className="nav d-flex align-items-center pb-0">
                    {(casualDiningService || multiDiningService) &&
                    subscriptionData?.seating?.value ? (
                      <>
                        {subscriptionData?.seating?.walkin_waitlist?.value ? (
                          <Button
                            variant="link"
                            className={`px-0 mr-4 text-grayLink f12-500 notify_text ${
                              this.state.insidePageTab === 1 ? "active" : ""
                            }`}
                            onClick={this.pageChangeButtonClickHandler(
                              1,
                              "SEATING"
                            )}
                          >
                            Walk-in / Waitlist
                          </Button>
                        ) : null}
                        {subscriptionData?.seating?.reservation?.value ? (
                          <Button
                            variant="link"
                            className={`px-0 mr-4 text-grayLink f12-500 notify_text ${
                              this.state.insidePageTab === 2 ? "active" : ""
                            }`}
                            onClick={this.pageChangeButtonClickHandler(
                              2,
                              "RESERVATION"
                            )}
                          >
                            Reservation
                          </Button>
                        ) : null}
                      </>
                    ) : null}
                    {(casualDiningService || multiDiningService) &&
                    subscriptionData?.event_management?.value ? (
                      <>
                        <Button
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          onClick={this.handleClick}
                          className={`px-0 mr-4 text-grayLink f12-500 notify_text ${
                            this.state.insidePageTab === 3 ||
                            this.state.insidePageTab === 4
                              ? "active"
                              : ""
                          }`}
                        >
                          Events
                        </Button>
                        <Menu
                          id="simple-menu"
                          anchorEl={this.state.anchorEl}
                          keepMounted
                          open={Boolean(this.state.anchorEl)}
                          getContentAnchorEl={null}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          onClose={this.handleClose}
                        >
                          {subscriptionData?.event_management?.offline_event
                            ?.rsvp?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(3, "RSVP")}
                            >
                              RSVP
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.event_management?.offline_event
                            ?.booking_enabled?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                4,
                                "TICKET_BOOKED"
                              )}
                            >
                              Ticket Booking
                            </MenuItem>
                          ) : null}
                        </Menu>
                      </>
                    ) : null}
                    {(casualDiningService ||
                        fastFoodDiningService ||
                        multiDiningService) &&
                      subscriptionData?.experience_management?.value ? (
                        <>
                          <Button
                            variant="link"
                            className={`px-0 mr-4 text-grayLink f12-500 notify_text ${
                              this.state.insidePageTab === 16 ? "active" : ""
                            }`}
                            onClick={this.pageChangeButtonClickHandler(
                              16,
                              "EXPERIENCE"
                            )}
                          >
                            Experience
                          </Button>
                        </>
                    ) : null}
                    {(casualDiningService ||
                      fastFoodDiningService ||
                      multiDiningService) &&
                    subscriptionData?.offer_management?.value ? (
                      <>
                        <Button
                          variant="link"
                          className={`px-0 mr-4 text-grayLink f12-500 notify_text ${
                            this.state.insidePageTab === 5 ? "active" : ""
                          }`}
                          onClick={this.pageChangeButtonClickHandler(
                            5,
                            "OFFERS"
                          )}
                        >
                          Offers
                        </Button>
                      </>
                    ) : null}
                    {(casualDiningService ||
                      fastFoodDiningService ||
                      multiDiningService) &&
                    subscriptionData?.ordering?.value ? (
                      <>
                        <Button
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          onClick={this.handleOrderingClick}
                          className={`px-0 mr-4 text-grayLink f12-500 notify_text ${
                            this.state.insidePageTab === 6 ||
                            this.state.insidePageTab === 7 ||
                            this.state.insidePageTab === 8 ||
                            this.state.insidePageTab === 9 ||
                            this.state.insidePageTab === 10 ||
                            this.state.insidePageTab === 11 ||
                            this.state.insidePageTab === 12 ||
                            this.state.insidePageTab === 13
                              ? "active"
                              : ""
                          }`}
                        >
                          <span className="f12-500">Ordering</span>
                        </Button>
                        <Menu
                          id="simple-menu"
                          getContentAnchorEl={null}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          anchorEl={this.state.ordering}
                          keepMounted
                          open={Boolean(this.state.ordering)}
                          onClose={this.handleOrderingClose}
                        >
                          {subscriptionData?.ordering?.take_away?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                6,
                                "TAKEAWAY"
                              )}
                            >
                              Take Away
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.cubside_delivery
                            ?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                7,
                                "CURBSIDE"
                              )}
                            >
                              Curbside
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.self_serve?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                8,
                                "SKIPTHELINE"
                              )}
                            >
                              Skip-the-line
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.dine_in_order?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(9, "DINEIN")}
                            >
                              Dine-In
                            </MenuItem>
                          ) : null}
                          {/* {subscriptionData?.ordering?.buffet?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(10, "BUFFET")}
                            >
                              Buffet
                            </MenuItem>
                          ) : null} */}
                          {subscriptionData?.ordering?.catering_banquet
                            ?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                11,
                                "CATERING"
                              )}
                            >
                              Catering
                            </MenuItem>
                          ) : null}
                          {/* {subscriptionData?.ordering?.drive_thru?.value ? (<MenuItem
                            onClick={this.onDropDownHandleClick(
                              12,
                              "DRIVETHRU"
                            )}
                          >
                            Drive Thru
                          </MenuItem>) : null} */}
                          {subscriptionData?.ordering?.home_delivery?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                13,
                                "HOMEDELIVERY"
                              )}
                            >
                              Home Delivery
                            </MenuItem>
                          ) : null}
                        </Menu>
                      </>
                    ) : null}
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500 notify_text ${
                        this.state.insidePageTab === 14 ? "active" : ""
                      }`}
                      onClick={this.pageChangeButtonClickHandler(14, "TICKET")}
                    >
                      User Ticket
                    </Button>
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500 notify_text ${
                        this.state.insidePageTab === 15 ? "active" : ""
                      }`}
                      onClick={this.pageChangeButtonClickHandler(15, "OTHER")}
                    >
                      Others
                    </Button>
                  </div>
                </div>
              </Media>
              <Media query="(max-width: 992px)">
                <div class="nav-scroller py-1 h-auto">
                  <div className="nav d-flex align-items-center pb-0">
                    {(casualDiningService || multiDiningService) &&
                    subscriptionData?.seating?.value ? (
                      <>
                        {subscriptionData?.seating?.walkin_waitlist?.value ? (
                          <Button
                            variant="link"
                            className={` mr-4 text-grayLink f9-400 notify_text ${
                              this.state.insidePageTab === 1 ? "active" : ""
                            }`}
                            onClick={this.pageChangeButtonClickHandler(
                              1,
                              "SEATING"
                            )}
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              minWidth: "auto",
                            }}
                          >
                            Walk-in / Waitlist
                          </Button>
                        ) : null}
                        {subscriptionData?.seating?.reservation?.value ? (
                          <Button
                            variant="link"
                            className={`px-0 mr-4 text-grayLink f9-400 notify_text ${
                              this.state.insidePageTab === 2 ? "active" : ""
                            }`}
                            onClick={this.pageChangeButtonClickHandler(
                              2,
                              "RESERVATION"
                            )}
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Reservation
                          </Button>
                        ) : null}
                      </>
                    ) : null}
                    {(casualDiningService || multiDiningService) &&
                    subscriptionData?.event_management?.value ? (
                      <>
                        <Button
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          onClick={this.handleClick}
                          className={`px-0 mr-4 text-grayLink f9-400 notify_text ${
                            this.state.insidePageTab === 3 ||
                            this.state.insidePageTab === 4
                              ? "active"
                              : ""
                          }`}
                          style={{ fontSize: "12px", fontWeight: "bold" }}
                        >
                          Events
                        </Button>
                        <Menu
                          id="simple-menu"
                          getContentAnchorEl={null}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          anchorEl={this.state.anchorEl}
                          keepMounted
                          open={Boolean(this.state.anchorEl)}
                          onClose={this.handleClose}
                        >
                          {subscriptionData?.event_management?.offline_event
                            ?.rsvp?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(3, "RSVP")}
                            >
                              RSVP
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.event_management?.offline_event
                            ?.booking_enabled?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                4,
                                "TICKET_BOOKED"
                              )}
                            >
                              Ticket Booking
                            </MenuItem>
                          ) : null}
                        </Menu>
                      </>
                    ) : null}
                    {(casualDiningService ||
                      fastFoodDiningService ||
                      multiDiningService) &&
                    subscriptionData?.offer_management?.value ? (
                      <>
                        <Button
                          variant="link"
                          className={`px-0 mr-4 text-grayLink f9-400 notify_text ${
                            this.state.insidePageTab === 5 ? "active" : ""
                          }`}
                          onClick={this.pageChangeButtonClickHandler(
                            5,
                            "OFFERS"
                          )}
                          style={{ fontSize: "12px", fontWeight: "bold" }}
                        >
                          Offers
                        </Button>
                      </>
                    ) : null}

                    {/* <Button
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={this.handleOrderingClick}
                      className={`px-0 mr-4 text-grayLink f9-400 notify_text ${
                        this.state.insidePageTab === 6 ||
                        this.state.insidePageTab === 7 ||
                        this.state.insidePageTab === 8 ||
                        this.state.insidePageTab === 9 ||
                        this.state.insidePageTab === 10 ||
                        this.state.insidePageTab === 11 ||
                        this.state.insidePageTab === 12 ||
                        this.state.insidePageTab === 13
                          ? "active"
                          : ""
                      }`}
                      style={{ fontSize: "12px", fontWeight: "bold" }}
                    >
                      Ordering
                    </Button> */}

                    {(casualDiningService ||
                      fastFoodDiningService ||
                      multiDiningService) &&
                    subscriptionData?.ordering?.value ? (
                      <>
                        <Button
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          onClick={this.handleOrderingClick}
                          className={`px-0 mr-4 text-grayLink f12-500 notify_text ${
                            this.state.insidePageTab === 6 ||
                            this.state.insidePageTab === 7 ||
                            this.state.insidePageTab === 8 ||
                            this.state.insidePageTab === 9 ||
                            this.state.insidePageTab === 10 ||
                            this.state.insidePageTab === 11 ||
                            this.state.insidePageTab === 12 ||
                            this.state.insidePageTab === 13
                              ? "active"
                              : ""
                          }`}
                          style={{ fontSize: "12px", fontWeight: "bold" }}
                        >
                          Ordering
                        </Button>

                        <Menu
                          id="simple-menu"
                          getContentAnchorEl={null}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                          anchorEl={this.state.ordering}
                          keepMounted
                          open={Boolean(this.state.ordering)}
                          onClose={this.handleOrderingClose}
                        >
                          {subscriptionData?.ordering?.take_away?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                6,
                                "TAKEAWAY"
                              )}
                            >
                              Take Away
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.cubside_delivery
                            ?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                7,
                                "CURBSIDE"
                              )}
                            >
                              Curbside
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.self_serve?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                8,
                                "SKIPTHELINE"
                              )}
                            >
                              Skip-the-line
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.dine_in_order?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(9, "DINEIN")}
                            >
                              Dine-In
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.buffet?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(10, "BUFFET")}
                            >
                              Buffet
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.catering_banquet
                            ?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                11,
                                "CATERING"
                              )}
                            >
                              Catering
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.drive_thru?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                12,
                                "DRIVETHRU"
                              )}
                            >
                              Drive Thru
                            </MenuItem>
                          ) : null}
                          {subscriptionData?.ordering?.home_delivery?.value ? (
                            <MenuItem
                              onClick={this.onDropDownHandleClick(
                                13,
                                "HOMEDELIVERY"
                              )}
                            >
                              Home Delivery
                            </MenuItem>
                          ) : null}
                        </Menu>
                      </>
                    ) : null}
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f9-400 notify_text ${
                        this.state.insidePageTab === 14 ? "active" : ""
                      }`}
                      style={{ fontSize: "12px", fontWeight: "bold" }}
                      onClick={this.pageChangeButtonClickHandler(14, "TICKET")}
                    >
                      User Ticket
                    </Button>
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f9-400 notify_text ${
                        this.state.insidePageTab === 15 ? "active" : ""
                      }`}
                      style={{ fontSize: "12px", fontWeight: "bold" }}
                      onClick={this.pageChangeButtonClickHandler(15, "OTHER")}
                    >
                      Others
                    </Button>
                  </div>
                </div>
              </Media>
              <div className="mt-3 mb-3 d-flex align-items-center">
                {this.state.insidePageTab === 1 && (
                  <Image
                    src={require("../../../assets/images/UserManagement/walkin.svg")}
                    fluid
                    alt="Walk-in / Waitlist"
                    title="Walk-in / Waitlist"
                    width="16px"
                  />
                )}
                {this.state.insidePageTab === 2 && (
                  <Image
                    src={require("../../../assets/images/UserManagement/reservation.svg")}
                    fluid
                    alt="Reservation"
                    title="Reservation"
                    width="20px"
                  />
                )}
                {this.state.insidePageTab === 3 ||
                this.state.insidePageTab === 4 ? (
                  <Image
                    src={require("../../../assets/images/ActionImages/event.svg")}
                    fluid
                    alt="Events"
                    title="Events"
                    width="20px"
                  />
                ) : null}
                {this.state.insidePageTab === 5 && (
                  <Image
                    src={require("../../../assets/images/ActionImages/tag.svg")}
                    fluid
                    alt="Offers"
                    title="Offers"
                    width="20px"
                  />
                )}
                {this.state.insidePageTab === 14 && (
                  <Image
                    src={require("../../../assets/images/ActionImages/user.svg")}
                    fluid
                    alt="User Ticket"
                    title="User Ticket"
                    width="20px"
                  />
                )}
                {this.state.insidePageTab === 15 && (
                  <Image
                    src={require("../../../assets/images/ActionImages/ring.svg")}
                    fluid
                    alt="Others"
                    title="Others"
                    width="20px"
                  />
                )}

                <div className="f20_500_HelveticaNeue pl-3">
                  {this.state.insidePageTab === 1
                    ? "Walk-in / Waitlist"
                    : this.state.insidePageTab === 2
                    ? "Reservation"
                    : this.state.insidePageTab === 3
                    ? "RSVP"
                    : this.state.insidePageTab === 4
                    ? "Ticket Booked"
                    : this.state.insidePageTab === 5
                    ? "Offers"
                    : this.state.insidePageTab === 6
                    ? "Take Away"
                    : this.state.insidePageTab === 7
                    ? "Curbside"
                    : this.state.insidePageTab === 8
                    ? "Skip The Line"
                    : this.state.insidePageTab === 9
                    ? "Dine-In"
                    : this.state.insidePageTab === 10
                    ? "Buffet"
                    : this.state.insidePageTab === 11
                    ? "Catering"
                    : this.state.insidePageTab === 12
                    ? "Drive Thru"
                    : this.state.insidePageTab === 13
                    ? "Home Delivery"
                    : this.state.insidePageTab === 14
                    ? "User Tickets"
                    : this.state.insidePageTab === 15
                    ? "Others"
                    : null}
                </div>
              </div>
              {/* {this.state.insidePageTab === 1 && ( */}
              {this.props.auth.loader ? (
                <React.Fragment>
                  <AmealioLoader />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {this.state.allSingleNotification.map((data, index) => (
                    <NotificationBlock
                      key={index}
                      data={data}
                      localProps={this.localProps}
                      insidePageTab={this.state.insidePageTab}
                      insidePageText={this.state.insidePageText}
                    />
                  ))}
                </React.Fragment>
              )}
              {/* )}
              {this.state.insidePageTab === 2 && (
                <React.Fragment>
                  {this.state.reservation.map((data, index) => (
                    <NotificationBlock
                      key={index}
                      data={data}
                      localProps={this.localProps}
                    />
                  ))}
                </React.Fragment>
              )}
              {this.state.insidePageTab === 5 && (
                <React.Fragment>
                  {this.state.pending.map((data, index) => (
                    <NotificationBlock
                      key={index}
                      data={data}
                      localProps={this.localProps}
                    />
                  ))}
                </React.Fragment>
              )} */}
              {/* <div className="main-notification-reusable">
                <h5>Reservation</h5>
                {this.state.reservation.map((data, index) => (
                  <NotificationBlock
                    key={index}
                    data={data}
                    localProps={this.localProps}
                  />
                ))}
                <h5>Walk-In / Waitlist</h5>
                {this.state.walkins.map((data, index) => (
                  <NotificationBlock
                    key={index}
                    data={data}
                    localProps={this.localProps}
                  />
                ))}
                <h5>Pending</h5>
                {this.state.pending.map((data, index) => (
                  <NotificationBlock
                    key={index}
                    data={data}
                    localProps={this.localProps}
                  />
                ))}
              </div> */}
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

Notification.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  clear_all_errors: PropTypes.func.isRequired,
  get_all_notifications: PropTypes.func.isRequired,
  get_single_notifications: PropTypes.func.isRequired,
  update_notification: PropTypes.func.isRequired,
  update_all_notification: PropTypes.func.isRequired,
  mark_all_as_read: PropTypes.func.isRequired,
  clear_all_as_read: PropTypes.func.isRequired,
  get_notification_count: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  notification: state.notifications.get_single_notification,
  notificationPageStatus: state.notifications.active_page_info,
  auth: state.auth,
  errors: state.errors.errors,
  /************* Active Service ************/
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  subscriptionData: state?.onboarding?.onboard_subscription_details
    ?.casual_dining
    ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
    : state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_all_notifications,
  get_single_notifications,
  update_notification,
  update_all_notification,
  mark_all_as_read,
  clear_all_as_read,
  get_notification_count,
})(withRouter(Notification));
